/* ===============================
   POPUP LOGIC – GLOBAL
================================ */

const EU_COUNTRIES = [
  "AT","BE","BG","HR","CY","CZ",
  "DK","EE","FI","FR","DE","GR","HU",
  "IE","IT","LV","LT","LU","MT",
  "NL","PL","PT","RO","SK","SI",
  "ES","SE"
];

function updateLocalizationPopup(currentTarget) {
  const popup_currency = document.querySelector('.popup-currency');
  const title = document.querySelector(".popup-title h3");
  const countryLine = document.querySelector(".popup-country");
  const shippingLine = document.querySelector(".popup-shipping-message");

  if (!title || !countryLine || !shippingLine) return;

  title.textContent = `Your location is set to ${currentTarget.querySelector('.country').innerText}`;
  countryLine.textContent = `Get shipping options for ${currentTarget.querySelector('.country').innerText}`;
  popup_currency.textContent  = `Shop in ${currentTarget.dataset.currency}`;

  if (currentTarget.dataset.value === 'NL') {
    shippingLine.innerHTML =
      "Enjoy <strong>FREE SHIPPING</strong> for orders above €120";
    return;
  }else if (EU_COUNTRIES.includes(currentTarget.dataset.value)){
     shippingLine.innerHTML =
      'Please note that all of our products ship from The Netherlands, for more information on shipping inside of the EU, please visit our <a href="/pages/shipping">shipping page</a>';
    return; 
  }else{
  shippingLine.innerHTML =
    'Please note that all of our products ship from The Netherlands, for more information on shipping and what this means if you are outside of the EU, please visit our <a href="/pages/shipping">shipping page</a>';
  }
}

function applyPopupFromCurrentCountry() {
  let current_selected_country = document.querySelector(".popular-countries a[aria-current='true']");
  if (current_selected_country) updateLocalizationPopup(current_selected_country);
}

document.addEventListener("DOMContentLoaded", applyPopupFromCurrentCountry);

/* ===============================
   LOCALIZATION DROPDOWNS
================================ */

if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector("button.localization-form__select"),
          panel: this.querySelector(".disclosure__list-wrapper")
        };

        if (this.elements.button) {
          this.elements.button.addEventListener("click", () => {
            if (!this.elements.panel) return;
            this.elements.panel.toggleAttribute("hidden");
            this.elements.button.setAttribute(
              "aria-expanded",
              (!this.elements.panel.hasAttribute("hidden")).toString()
            );
          });
        }

        this.querySelectorAll("a").forEach(item =>
          item.addEventListener("click", this.onItemClick.bind(this))
        );
      }

      closePanel() {
        if (!this.elements.panel) return;
        this.elements.panel.setAttribute("hidden", true);
        if (this.elements.button) {
          this.elements.button.setAttribute("aria-expanded", "false");
        }
      }

      onItemClick(event) {
        event.preventDefault();
        console.log("event.currentTarget",event.currentTarget);
        const form = this.querySelector("form");
        if (!form || !this.elements.input) return;

        /* Update UI label + checkmark */
        const wrapper = event.currentTarget.closest("localization-form");
        if (wrapper) {
          wrapper.querySelectorAll(".lozalization_list_anchor_tag span")
            .forEach(span => span.classList.add("visibility-hidden"));

          event.currentTarget.querySelector("span")
            ?.classList.remove("visibility-hidden");

          const label = wrapper.querySelector(".localization_active_detail_lable");
          if (label && event.currentTarget.dataset.full_detail) {
            label.innerText = event.currentTarget.dataset.full_detail;
          }
        }

        /* Mark form changed */
        form.classList.add("form_value_changed");

        /* Set correct value */
        if (this.elements.input.name === "locale_code") {
          this.elements.input.value =
            event.currentTarget.dataset.value ||
            event.currentTarget.dataset.locale;
        } else {
          this.elements.input.value = event.currentTarget.dataset.value;
        }

        /* Update popup only for country */
        if (this.elements.input.name === "country_code") {
          // const countryName = event.currentTarget.querySelector(".country")?.innerText;
          //   console.log("countryName",countryName);

          updateLocalizationPopup(event.currentTarget);
        }

        this.closePanel();
      }
    }
  );
}

/* ===============================
   CONFIRM BUTTON – FINAL LOGIC
================================ */

window.localization_submit_click = (submit_btn) => {
  const langForm = document.querySelector("#HeaderLanguageForm");
  const countryForm = document.querySelector("#HeaderCountryForm");

  const langChanged = langForm?.classList.contains("form_value_changed");
  const countryChanged = countryForm?.classList.contains("form_value_changed");

  submit_btn.classList.add("active");

  /* 🔴 LANGUAGE CHANGE MUST BE NATIVE SUBMIT */
  if (langChanged) {
    langForm.submit();
    return;
  }

  /* Country-only can be AJAX */
  if (countryChanged) {
    fetch(countryForm.action, {
      method: "POST",
      body: new FormData(countryForm),
      credentials: "same-origin"
    })
    .then(() => {
      // localStorage.setItem('user_country_already_change',true);
      window.location.reload()
    })
    .catch(console.error);
  }
};

/* ===============================
   POPUP OPEN / CLOSE
================================ */

window.close_localization = () => {
  document.querySelector(".localization_wrapper_containor")
    ?.classList.add("hide_localization");
  document.querySelector(".localization_overlap")
    ?.classList.remove("localization_overlap_show");
  // localStorage.setItem('user_country_already_change',true);
};

window.open_localization = () => {
  document.querySelector(".localization_wrapper_containor")
    ?.classList.remove("hide_localization");
  document.querySelector(".localization_overlap")
    ?.classList.add("localization_overlap_show");
};




let user_real_country_locSto = localStorage.getItem('user_real_country_locSto');
let user_country_already_change = localStorage.getItem('user_country_already_change');
if(user_real_country_locSto == null){
  localStorage.setItem('user_real_country_locSto',Shopify.country);
}else if(user_real_country_locSto != Shopify.country && user_country_already_change == null){
  setTimeout(() => {
    let user_real_country_from_country_dropd = document.querySelector(`.localization_selector_wrapper .country-selector__list .lozalization_list_anchor_tag[data-value="${user_real_country_locSto}"]`);
    user_real_country_from_country_dropd && user_real_country_from_country_dropd.dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
    updateLocalizationPopup(user_real_country_from_country_dropd);
    let wrong_country_msg = document.querySelector(".wrong_country_msg");
    wrong_country_msg && wrong_country_msg.classList.remove('hidden');
    window.open_localization();
  }, 2000);
  localStorage.setItem('user_country_already_change',true);
}